(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PresentListProductDetailController', PresentListProductDetailController);

    PresentListProductDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PresentListProduct', 'Product', 'PresentList'];

    function PresentListProductDetailController($scope, $rootScope, $stateParams, entity, PresentListProduct, Product, PresentList) {
        var vm = this;
        vm.presentListProduct = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:presentListProductUpdate', function(event, result) {
            vm.presentListProduct = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
